export const isMobileDevice = () => {
  const result: boolean = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    || /iPad|iPhone|iPod/.test(navigator.platform)
    || (navigator?.maxTouchPoints > 1);

  return result
}